module.exports = __webpack_public_path__ + "img/csr_swiper_04.c3075fc4.jpg";